import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminListViewComponent } from '../list-view/admin-list-view.component';

@Component({
  selector: 'exam-admin-container',
  template: ` <exam-admin-list-view /> `,
  host: { class: 'h-full block' },
  imports: [AdminListViewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminContainerComponent {}
